import { render, staticRenderFns } from "./HipaaFormValidation.vue?vue&type=template&id=2ee552da&scoped=true"
import script from "./HipaaFormValidation.vue?vue&type=script&lang=js"
export * from "./HipaaFormValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee552da",
  null
  
)

export default component.exports